function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><rect fill="#D46147" width="56" height="56" rx="10" /><path d="M24.333 32.938l-5.247-5.247a1.222 1.222 0 0 0-1.728 1.729l6.111 6.11a1.222 1.222 0 0 0 1.729 0l13.444-13.444a1.222 1.222 0 1 0-1.728-1.728l-12.58 12.58z" fill="#FFF" fillRule="nonzero" /></g></svg>;
});